import React from 'react';
import { imageAssets } from '../../assets/imageAssets';

interface ScreenSplashProps {
  show: boolean;
  title: string;
  subtitle?: string;
}

export default function ScreenSplash({ show, title, subtitle }: ScreenSplashProps) {
  return (
    <div
      className={`fixed inset-0 z-[200] flex items-center justify-center bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 transition-opacity duration-700 ${
        show ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
      aria-hidden={!show}
    >
      <style>{`
        @keyframes splashLogoSpin {
          0% { transform: rotateY(0deg); }
          100% { transform: rotateY(360deg); }
        }
      `}</style>

      <div className="text-center px-6">
        <div className="mx-auto mb-6 [perspective:1000px]">
          <div
            className="relative w-20 h-20 mx-auto"
            style={{
              animation: 'splashLogoSpin 2.2s linear infinite',
              transformStyle: 'preserve-3d',
            }}
          >
            <img
              src={imageAssets.imdcLogo}
              alt="IMDC Creative Works Logo"
              className="absolute inset-0 w-20 h-20 rounded-full object-cover ring-4 ring-white shadow-xl [backface-visibility:hidden]"
            />
            <img
              src={imageAssets.bisuLogo}
              alt="BISU Logo"
              className="absolute inset-0 w-20 h-20 rounded-full object-cover ring-4 ring-white shadow-xl [transform:rotateY(180deg)] [backface-visibility:hidden]"
            />
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent mb-2">
          {title}
        </h2>
        {subtitle && <p className="text-gray-600 font-medium">{subtitle}</p>}
      </div>
    </div>
  );
}
